import noUiSlider from 'nouislider';

export default () => {

  const slider = document.getElementById('slider-round');
  const table = document.querySelector('.table');

  if(!table) return;

  const tableRows = table.querySelectorAll('[data-area]');
  const numbers = [...tableRows].map(row => row.dataset.area);

  const max = Math.max(...numbers);

  if(slider) {
    noUiSlider.create(slider, {
      start: [0, max],
      connect: true,
      // margin: 100,
      step: 100,
      range: {
          'min': 0,
          'max': max
      }
    });

    const filterTable = (firstFilteredValue, secondFilteredValue) => {

      [...tableRows].forEach((row) => {
        if(+row.dataset.area >= +firstFilteredValue && +row.dataset.area <= +secondFilteredValue) {
          row.style.display = "flex";

        } else {
          row.style.display = "none";
        }
      })
    }

    slider.noUiSlider.on('update', (value) => {
      const firstValue = document.querySelector('.building__value--first .building__value-number');
      const secondValue = document.querySelector('.building__value--second .building__value-number');
      const firstFilteredValue = value[0].slice(0, -3);
      const secondFilteredValue = value[1].slice(0, -3);

      firstValue.innerHTML = firstFilteredValue;
      secondValue.innerHTML = secondFilteredValue;
      filterTable(firstFilteredValue, secondFilteredValue);
    });
  }
}